import { Component, Log, CacheStorage } from '@WidgetWorks';

export default class RecommendationCTA extends Component {
    constructor(appConfig) {
        super(appConfig);
        this.interacted = false;
    }

    overrideHook() {
        return true;
    }

    preRenderHook() {
        return true;
    }

    beforeMountHook() {
        this.root = this.element.shadowRoot.querySelector('section');
        return true;
    }

    postElementMount() {
        // see retailer config
        return true;
    }

    postRenderHook() {
        // Any animations, would be a good idea to apply here.
        // Now it's been rendered, note that this counts as a button display event
        // this.analytics.registerEvent('button_display', 1, 'FCBP');
        return true;
    }

    topLevelClickAnalytics() {
        this.analytics.registerEvent('button_click', 1, 'VisualSearchParentApp');

        // Check if the user is unique.
        const flagExists = CacheStorage.get('PRIME_AI_VISUAL_SEARCH_FIRST_CLICKED_BUTTON');

        // If the user is unique, register a unique visitor event.
        // and set a flag to say they are no longer unique.
        if (!flagExists) {
            this.analytics.registerEvent('button_clickfirsttime', 1, 'VisualSearchParentApp');
            CacheStorage.set('PRIME_AI_VISUAL_SEARCH_FIRST_CLICKED_BUTTON', true, CacheStorage.expirationEndOfDay());
        }
    }

    firstClickAnalytics() {
        const firstClickedFlag = CacheStorage.get('PRIME_AI_FCBP_APP_FIRST_CLICKED_BUTTON');
        if (firstClickedFlag) return false;
        this.analytics.registerEvent('button_clickfirsttime', 1, 'FCBP');
        CacheStorage.set('PRIME_AI_FCBP_APP_FIRST_CLICKED_BUTTON', true, CacheStorage.expirationEndOfDay());
        return true;
    }

    firstInteractionHook() {
        if (this.interacted) return false;
        this.interacted = true;
        console.log(...Log.w('RecommendationCTA', 'LOG', 'First Interaction'));

        // First time they clicked the button analytical event
        // will run at the same time as button click.
        this.firstClickAnalytics();
        return true;
    }

    async init() {
        console.log(...Log.w('RecommendationCTA', 'LOG', 'Initialising...'));

        // This hook will run the custom function defined in the override itself.
        this.overrideHook();

        // ! 0.6, grab the product-ids ahead of time
        // ! and check they exist.
        // ! maintain an internal memo of existing products / non existing
        // ! make a note of all of those existing / not exist.
        // ! during the mounting phase, if the product is not found, don't mount it. isElementAllowedToMount()
        // Before rendering, do these things.
        this.preRenderHook();

        // Insert CSS into virtual element
        this.insertCSS(this.styles);

        // Insert HTML into virtual element
        this.insertHTML(this.markup);

        // Update HTML with Languages into the virtual element
        this.insertLanguages(this.language);

        // Run the pre mounted hook.
        this.beforeMountHook();

        // Once the mount point is available, create copies
        // and mount it.
        await this.mountElements();

        // Now mounted, run the post hooks
        this.postRenderHook();

        console.log(...Log.w('RecommendationCTA', 'LOG', 'Initialised'));
    }

    insertLanguages(langs) {
        // Dynamic insertion using a recursive post order
        // technique is the default function to insertion of languages
        // feel free to override.
        this.recursiveLanguageInsertion(langs, '');
        return true;
    }

    async mountElements() {
        // use the standard one.
        const result = await this.mountComponentToPoints();
        return result;
    }

    createEventListeners(elements) {
        for (const element of elements) {
            const elm = this.getElementRoot(element);
            elm.addEventListener('click', () => {
                this.openRecommendationWindow();
            });
        }
    }

    openRecommendationWindow() {
        // Analytics for someone has clicked the button
        this.analytics.registerEvent('button_click', 1, 'FCBP');
        this.topLevelClickAnalytics();

        // Set into localstorage.

        this.firstInteractionHook();
        this.connections.recommendationWindow.connectionDisplayApp();
    }
}
